<div class="header-bar-desktop-root">
  <div class="header-container" *ngIf="!loading">
    <div class="date">
      {{ date | date: 'fullDate' : '' : admin?.language }}
    </div>
    <div class="user-area">
      <div id="header-bar-home-desktop-expand" class="region-name" [matMenuTriggerFor]="userMenu.menu">
        {{ currentRegion?.name| uppercase }} - {{ admin?.name }}
        <mat-icon class="more">expand_more</mat-icon>
        <app-profile-menu #userMenu [profileMenuItems]="profileMenuItems"></app-profile-menu>
      </div>
      <div class="picture">
        <mat-icon *ngIf="!admin?.picture" class="picture-area-user">account_circle</mat-icon>
        <img *ngIf="admin?.picture" src="{{admin?.picture}}" alt="{{alt}}">
      </div>
    </div>
  </div>
  <mat-spinner
  *ngIf="loading"
  class="loading"
  diameter="50">
  </mat-spinner>
</div>
